import React from 'react';
import './Popup.css';
import { Loading } from '../shared';
import axios from "axios";

//The pop-up window would make the api call and display the pdf preview via blob url
class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showPopup: true, isLoading: true, pdfURL: "some string" };
  }

  componentDidMount() {
    var imageURL = "";
    var fileType = ".tif";
    if (this.props.drive === "R") {
      //RCRA URL
      imageURL = `/api/v1/hwts/manifest-images/rcra/preview?manifestID=${this.props.manifestID}`;
      fileType = ".pdf"
    }
    else if (this.props.docAiManifestImageId) {
      //Doc AI manifest image URL
      // all Doc AI manifest images are single PDFs, so we can use the download endpoint
      imageURL = `/api/v1/hwts/manifest-images/doc-ai/download?id=${this.props.docAiManifestImageId}`;
      fileType = ".pdf"
    }
    else {
      //Local URL
      if (this.props.drive === "E") {
        fileType = ".pdf";
      }
      // endpoint not implemented yet
      imageURL = `/api/v1/hwts/manifest-images/dtsc/preview?drive=${this.props.drive}&DPath=${this.props.DPath}&path=${this.props.path}&&fileName=${this.props.fileName}${fileType}`;
    }
    axios({
      url: imageURL,
      method: 'GET',
      responseType: 'blob', // important
    }).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      console.log(imageURL)
      this.setState({ pdfURL: url, isLoading: false });
    }).catch((err) => {
      alert("This file type cannot be previewed, please download the manifest image to view it.");
    });

  }
  render() {
    const isLoading = this.state.isLoading;
    return (this.state.showPopup) ? (
      <div className='popup-container'>
        <div className='popup-outer'>
          <button className='close-btn' onClick={() => this.setState({ showPopup: false })}>&#10006;</button>
          <div className='popup-inner'>
            {isLoading ? (<div style={{ paddingBottom: 100 }}>
              <Loading />
            </div>) : (<iframe src={this.state.pdfURL} title="manifest image preview" type="application/pdf" width="100%" height="100%"></iframe>)
            }
          </div>
        </div>
      </div>
    ) : "";
  }
}

export default Popup;